export const WS_SET_FETCHING = 'WS_SET_FETCHING'
